export function resetEmailTransactionModal() {
  return { type: 'EMAIL_TRANSACTION_MODAL_RESET' };
}

export function showEmailTransactionModal() {
  return { type: 'EMAIL_TRANSACTION_MODAL_SHOW' };
}

export function hideEmailTransactionModal() {
  return { type: 'EMAIL_TRANSACTION_MODAL_HIDE' };
}

export function toggleEmailTransactionModal() {
  return { type: 'EMAIL_TRANSACTION_MODAL_TOGGLE' };
}

export function initEmailTransactionModal(id, docType) {
  return { type: 'EMAIL_TRANSACTION_MODAL_INITIALIZE', payload: { id, docType } };
}

export function setEmailTransactionModalLoading(loading) {
  return { type: 'EMAIL_TRANSACTION_MODAL_SET_LOADING', payload: loading };
}

export function setEmailTransactionModalData(data) {
  return { type: 'EMAIL_TRANSCTION_MODAL_SET_DATA', payload: data };
}

